module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "destination-detail"
  }, [(_vm.isSpot) ? _c('state-spot') : _vm._e(), _vm._v(" "), (_vm.isRestRoom) ? _c('state-restroom') : _vm._e(), _vm._v(" "), (_vm.isPerson) ? _c('state-person') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-349623f6","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/destination/detail.vue
// module id = 612
// module chunks = 0